<script>
  import { onMount } from "svelte";
  import { getNotificationsContext } from "svelte-notifications";
  import ImportStepDataCard from "./parts/ImportStepDataCard.svelte";
  import GeneralButton from "../../../../components/button/GeneralButton.svelte";
  import ImportStepDataCardSettingsContent from "./parts/ImportStepDataCardSettingsContent.svelte";
  import UploadDataDialog from "../parts/UploadDataDialog.svelte";
  import { getAutoMpsProjectContext } from "../../../AutoMpsProjectContext.js";
  import { localizeTableData } from "./parts/tableUtils.js";
  import ImportStepDataCardCaption from "./parts/ImportStepDataCardCaption.svelte";
  import ImportsTable from "../../../parts/ImportsTable.svelte";
  import { constructImportsTableHeaders } from "../../../parts/ImportsTableUtils.js";

  export let selectedParameterDataId = "1"
  const ctx = getAutoMpsProjectContext()
  const {addNotification} = getNotificationsContext()

  let isImportsLoaded = false
  let parameterDataImports = null
  async function getParameterDataImports() {
    const {imports} = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/imports/parameter`)
      .then(res => res.json())
    parameterDataImports = imports
    isImportsLoaded = true
  }

  $: if (selectedParameterDataId === "latest" && parameterDataImports && parameterDataImports.length > 0) {
    selectedParameterDataId = parameterDataImports[0].id
  }

  let isUploadDataDialogOpen = false

  async function createNewManualImport(rows, originalCsvData) {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/imports/parameter?useMappings=true`, {
      method: "POST",
      body: JSON.stringify({
        meta: {
          importMethod: "manual",
        },
        data: rows,
        originalCsvData,
      }),
      headers: {
        "Content-Type": "application/json",
      }
    })
    if (!response.ok) {
      return addNotification({
        text: "ファイルのアップロードに失敗しました。",
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });
    }

    addNotification({
      text: "ファイルをアップロードしました。",
      position: "top-right",
      removeAfter: 4000,
      type: "success",
    });

    // refresh the displayed data and select the newly uploaded data
    await getParameterDataImports()
    selectedParameterDataId = "latest"

    isUploadDataDialogOpen = false
  }

  onMount(async () => {
    await getParameterDataImports()
  })
</script>

<ImportStepDataCard
  title="⑦：平準化パラメタデータ"
  dataType="parameter"
  selectedImportId={selectedParameterDataId}
>
  <ImportStepDataCardCaption
    isImportsLoaded={isImportsLoaded}
    isLatestSelected={selectedParameterDataId === "latest" || selectedParameterDataId === parameterDataImports?.[0]?.id}
    importedAt={parameterDataImports?.find(row => row.id === selectedParameterDataId)?.importedAt}
  />
  <ImportStepDataCardSettingsContent slot="open">
    <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 1rem;">
      <div>使用するデータを設定します。</div>
      <GeneralButton buttonSize="small" onClick={() => isUploadDataDialogOpen = true}>
        新しいインポートを作成する
      </GeneralButton>
    </div>
    {#if parameterDataImports}
      <ImportsTable
        bind:selectedRowId={selectedParameterDataId}
        headers={constructImportsTableHeaders({insertRadio: true, insertViewImportButton: true})}
        rows={localizeTableData(parameterDataImports)}
        dataType="parameter"
      />
    {:else}
      <span>Loading...</span>
    {/if}
  </ImportStepDataCardSettingsContent>
</ImportStepDataCard>
{#if isUploadDataDialogOpen}
  <UploadDataDialog
    onClose={() => isUploadDataDialogOpen = false}
    uploadTo={`/api/auto-mps/projects/${$ctx.projectId}/imports/parameter`}
    onClickUpload={createNewManualImport}
  />
{/if}
